__turbopack_context__.v({
  "collapseButton": "side-menu-module__ZYYwba__collapseButton",
  "expBadge": "side-menu-module__ZYYwba__expBadge",
  "label": "side-menu-module__ZYYwba__label",
  "policyLinks": "side-menu-module__ZYYwba__policyLinks",
  "root": "side-menu-module__ZYYwba__root",
  "soonBadge": "side-menu-module__ZYYwba__soonBadge",
});
